import React, { useEffect, useState } from "react";
import { ContentState, convertFromRaw, convertToRaw, EditorState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { Controller, useController } from "react-hook-form";
import { FormInputLabel, FormItemContainer } from "../StyledComponents";
import Grid from "@material-ui/core/Grid";
import htmlToDraft from 'html-to-draftjs';
import draftToHtml from "draftjs-to-html";


const EditorTextControlled = ({
  name,
  control,
  rules,
  label,
  placeholder,
  style,
  disabled,
  onChangeDefault,
  onPress,
  notRequired = false,
  requiredColor = '#0061C6',
  maxLength = 140,
  showMaxLengthLabel = false,
  borderRadius = '',
  ...props
}) => {
  
  const {
    fieldState: {error},
    field: { onChange, value },
  } = useController({ control, name, rules });
  
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [currentValue, setCurrentValue] = useState(value);
  const [firstRender, setFirstRender] = useState(false);
  
  useEffect(() => {
    if(value && !firstRender) {
      setCurrentValue(value)
      setFirstRender(true);
    }
    // https://github.com/facebook/create-react-app/issues/6880
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value])
  
  useEffect(() => {
    if (currentValue) {
      const contentBlocks = htmlToDraft(currentValue);
      const contentState = ContentState.createFromBlockArray(
          contentBlocks.contentBlocks,
          contentBlocks.entityMap
      );
     setEditorState(EditorState.createWithContent(contentState));
    }
  }, [currentValue]);
  
  
  const onEditorStateChange = (newEditorState) => {
    setEditorState(newEditorState);
    const html = draftToHtml(convertToRaw(newEditorState.getCurrentContent()))
    onChange(html);
  };
  
  useEffect(() => {
    if (value) {
      try {
        const contentStateAsRaw = JSON.parse(value);
        const contentState = convertFromRaw(contentStateAsRaw);
        setEditorState(EditorState.createWithContent(contentState));
      } catch (error) {
        console.error("Error parsing content from field value:", error);
      }
    }
  }, [value]);
  
  const renderError = () =>
      error && error.message ? (
          <p
              style={{
                color: error?.message ? '#F5365C' : '#000000',
              }}
          >
            {error?.message}
          </p>
      ) : null;
  
  
  return (
      
      <FormItemContainer>
        <FormInputLabel>
          <label>
            {label ?? placeholder}{' '}
            {!notRequired && <strong style={{color: requiredColor}}>*</strong>}
          </label>
        </FormInputLabel>
  
        <Controller
            name={name}
            control={control}
            render={({ field }) => (
                <Editor
                    editorState={editorState}
                    onEditorStateChange={onEditorStateChange}
                    wrapperClassName="demo-wrapper"
                    editorClassName="wysiwyg-editor"
                />
            )}
        />

        {!!showMaxLengthLabel && (
            <Grid item container flexDirection={'row'}>
              <Grid item md={10}>
                <>{renderError()}</>
              </Grid>
              <Grid
                  item
                  md={2}
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    paddingRight: '10px',
                  }}
              >
                <FormInputLabel>{`${
                    value?.toString()?.length ?? 0
                }/${maxLength}`}</FormInputLabel>
              </Grid>
            </Grid>
        )}
      </FormItemContainer>
  );
};

export default EditorTextControlled;
